<template>
  <span v-if="$can(permissions.WAREHOUSE.CREATE_PALLET_RECEIPT)">
    <el-tooltip class="item" effect="dark" :content="$t('admin.palletReceipt.tooltip')" placement="top-start">
      <el-button
          id="btn-pallet-receipt"
          type="success"
          plain
          @click="dialogVisible = true"
          size="mini"
      >
        {{ $t('admin.palletReceipt.title') }}
      </el-button>
    </el-tooltip>
    <el-dialog
        :title="$t('admin.palletReceipt.title')"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="25%"
        append-to-body
        class="dialog-with-cols"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('admin.palletReceipt.dayOfService')" prop="dayOfService"
                          class="inline-input">
              <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="form.dayOfService"
                  format="MM/dd/yyyy"
                  :clearable="false"
                  type="date"
                  style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" @click="submitForm()" size="mini">{{ $t('admin.palletReceipt.title') }}</el-button>
        <el-button id="form-clear-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'CreatePalletReceipt',
  data() {
    return {
      dialogVisible: false,
      form: {
        dayOfService: null
      },
      formRules: {
        dayOfService: [
          {
            required: true,
            message: this.$t('admin.palletReceipt.error.dayOfServiceRequired'),
            trigger: 'blur'
          },
        ],
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('palletReceipt/runPalletReceipt', this.form)
            .then((response) => {
              loading.close();
              this.$message.success(response.message);
              this.dialogVisible = false;
            })
            .catch(() => {
              loading.close();
            });
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.dayOfService = null;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-pallet-receipt {
  margin-right: 10px;
}
</style>
